import random from 'toxilibs/random.js'
import Level from '../core/level.js'

const level = new Level({
    name: 'proportionality_icons',
    dependencies: []
})


function successiveSymbols (symbol, count) {
    let s = ''
    for (let i = 0; i < count; i++) {
        s += symbol
    }
    return s
}

function common (q, value, countA, countB) {
    q.addText(successiveSymbols('i_black_star', countA) + ' -> ' + (countA * value))
    q.addText(successiveSymbols('i_black_star', countB) + ' -> ANSWER_HERE')
    q.answer = countB * value
    q.addBadChoices(
        countA * countB * value,
        countA * countA * value,
        () => random.intBetween(1, Math.max(countA, countB) + 1) * value,
        () => random.intBetween(1, (Math.max(countA, countB, 4) + 1) * Math.max(2, value))
    )
}


level.addQuestion({
    generator: function (q) {
        let count = random.fairChoice([2, 3, 4])
        common(q, 1, 1, count)
    }
})


level.addQuestion({
    generator: function (q) {
        let value = random.fairChoice([2, 3, 4, 5, 6, 7, 8, 10, 20, 30, 40, 100, 200])
        common(q, value, 1, 2)
    }
})


level.addQuestion({
    generator: function (q) {
        let value = random.fairChoice([2, 3, 4, 5, 10, 20, 30, 100, 200])
        common(q, value, 1, 3)
    }
})


level.addQuestion({
    generator: function (q) {
        q.smartChoose([
            {1:   {count: 3, value: [2, 3, 10, 20, 100]}},
            {all: {count: [2, 3, 4], value: [2, 3, 10, 20, 30, 100, 200]}}
        ], function (choices) {
            common(q, choices.value, choices.count, 1)
        })
    },
    times: 2
})


level.addQuestion({
    generator: function (q) {
        let value = random.fairChoice([2, 3, 10, 20, 30, 100, 200], {name: 'value'})
        let count = random.fairChoice([3, 4], {name: 'count'})
        common(q, value, 2, count)
    },
    times: 2
})







export default level

